import { boot, h, t, tl } from './dom.js';

export interface StartActions {
  start(url: string, consent: boolean): Promise<void>;
}

/** `address`: the website of the run the visitor leaves with «Neu starten», already in the box. */
export function renderStart(actions: StartActions, message: { kind: 'error' | 'info'; text: string } | null, address: string | null = null): HTMLElement {
  const root = h('section', { class: 'stage on' });
  root.append(h('h1', {}, `${t('start.h1')} `, h('b', {}, t('start.h1_bold'))));
  root.append(h('p', { class: 'lead' }, t('start.lead')));
  const steps = (boot.strings as { start?: { steps?: { text: string; time: string }[] } }).start?.steps ?? [];
  root.append(h('ol', { class: 'steps' }, steps.map((step) => h('li', {}, h('div', {}, step.text, h('em', {}, step.time))))));

  const errorBox = h('p', { class: message?.kind === 'info' ? 'info' : 'error', hidden: !message }, message?.text ?? '');
  const url = h('input', { type: 'url', id: 'url', value: address ?? '', placeholder: t('start.url_placeholder'), 'aria-label': t('start.url_label'), autocomplete: 'url', inputmode: 'url' });
  const consent = h('input', { type: 'checkbox', id: 'consent' });
  const button = h('button', { class: 'btn block', id: 'start' }, t('start.submit'));
  const form = h(
    'form',
    { class: 'card', novalidate: 'novalidate' },
    errorBox,
    h('label', { class: 'field' }, h('span', {}, t('start.url_label')), url),
    h('label', { class: 'check' }, consent, ' ', h('span', {}, t('start.consent'))),
    button
  );
  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    errorBox.hidden = true;
    errorBox.className = 'error';
    if (!url.value.trim()) {
      errorBox.textContent = t('start.errors.url_invalid');
      errorBox.hidden = false;
      return;
    }
    if (!consent.checked) {
      errorBox.textContent = t('start.errors.consent_required');
      errorBox.hidden = false;
      return;
    }
    button.disabled = true;
    button.textContent = t('start.submit_busy');
    try {
      await actions.start(url.value.trim(), true);
    } catch (error) {
      const code = (error as { code?: string }).code ?? 'generic';
      errorBox.textContent = t(`start.errors.${['url_invalid', 'url_scheme', 'url_not_public', 'url_unresolvable', 'consent_required', 'rate_limited'].includes(code) ? code : 'generic'}`);
      errorBox.hidden = false;
      button.disabled = false;
      button.textContent = t('start.submit');
    }
  });
  root.append(form);
  root.append(h('p', { class: 'scope' }, t('start.scope')));

  root.append(h('h2', {}, t('start.sample_h2')));
  const sample = h('div', { class: 'finding' }, h('span', { class: 'tag high' }, t('start.sample_tag')), h('h3', {}, t('start.sample_title')));
  const quotes = (boot.strings as { start?: { sample_quotes?: { text: string; src: string }[] } }).start?.sample_quotes ?? [];
  for (const quote of quotes) sample.append(h('div', { class: 'q' }, quote.text, h('span', { class: 'src' }, quote.src)));
  sample.append(h('p', { class: 'small muted', style: 'margin:8px 0 0' }, t('start.sample_note')));
  root.append(sample);
  void tl;
  return root;
}
